import { _isNumberValue } from '@angular/cdk/coercion';
import { CurrencyPipe } from '@angular/common';
import { Injectable, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { EnumService } from 'app/core/services/enum.service';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CurrencyType, Language } from '../model/enums';
import { LAST_CONNECTED_LANGUAGE } from '../model/local-storage-keys';
import { setCurrency, setLanguage } from '../state/actions/‏‏shared-common.action';

@Injectable()
export class LocalizationService {
    currentLanguage: Language;
    constructor(private translate: TranslateService, private _enumService: EnumService, private store: Store<AppState>,
        private activatedRoute: ActivatedRoute) {

    }

    getEnumValuesTranslation(enumType: any, customEnumName: any = null): Observable<{ label: string, value: any }[]> {
        const enumsValues = this._enumService.getEnumValues(enumType);
        const enumName = customEnumName ? customEnumName : this._enumService.getEnumName(enumType);
        return this.TranslateAsync(`ENUMS.${enumName}`).pipe(switchMap(translations => {
            return of(enumsValues.map(v => {
                return { label: translations[enumType[v]], value: v };
            }));
        }));
    }
    TranslateEnum(value: number, enumType: any, customEnumName: string = null) {
        const enumName = customEnumName ? customEnumName : this._enumService.getEnumName(enumType);
        return this.TranslateAsync('ENUMS.' + enumName + '.' + enumType[value]);
    }
    Translate(value: string, params: any = {}) {
        return this.translate.instant(value, params);
    }
    TranslateAsync(value: string, params: any = {}) {
        return this.translate.get(value, params);
    }

    changeLanguage(language: Language) {
        if (this.currentLanguage !== language) {
            this.setCurrencyByLanguage(language);
            this.translate.use(Language[language]);
            setTimeout(() => {
                this.store.dispatch(setLanguage({ language }));
            }, 1000);
            this.currentLanguage = language;
        }
    }
    private setCurrencyByLanguage(language: Language) {
        let currency;
        switch (language) {
            case Language.he:
                currency = CurrencyType.ILS;
                break;
            default:
                currency = CurrencyType.USD;
        }
        this.store.dispatch(setCurrency({ currency }));
    }

    InitializeLanguage() {
        const hostname = window.location.hostname;
        let language
        if (hostname === 'spintuwin.com') {
            this.translate.setDefaultLang(Language[Language.he]);
            language = Language.he;
            const lastLanguage = localStorage.getItem(LAST_CONNECTED_LANGUAGE);
            if (lastLanguage && !isNaN(parseInt(lastLanguage))) {
                language = parseInt(lastLanguage);
            }
        }
        else if(hostname === 'spintowindiners.com')
          {
            this.translate.setDefaultLang(Language[Language.en]);
            language = Language.en;
          }
          else{
            this.translate.setDefaultLang(Language[Language.en]);
            language = Language.en;
          }

        this.changeLanguage(language)

        this.activatedRoute.queryParams.subscribe(params => {
            const languageParam = params['lang'];
            let changeToLanguage;

            if (languageParam) {
                if (_isNumberValue(languageParam)) {
                    changeToLanguage = parseInt(languageParam);
                } else {
                    const lang = languageParam.trim().toLowerCase();
                    if (lang == 'en' || lang == 'bg') {
                        changeToLanguage = Language.en;
                    } else if (lang == 'he') {
                        changeToLanguage = Language.he;
                    }

                }
                if (changeToLanguage != language) {
                    this.changeLanguage(changeToLanguage);
                }

            }
        });
    }
}
